import { Link } from "react-router-dom"
import BannerImg1 from "../images/img-1.jpg"
import Anaesthesiology from "../images/Anaesthesiology.jpg"
import GeneralMedicine from "../images/General Medicine.jpg"
import Obstetrics from "../images/Obstetrics & Gynaecology (2).jpg"
import Orthopaedics from "../images/Orthopaedics (1).jpg"
import SEO from './SEO';
import {
  // Common medical / healthcare icons
  HeartPulse,
  Activity,
  Brain,
  Microscope,
  Stethoscope,
  Syringe,
  Scissors,
  Droplet,
  FlaskConical,
  UserRound,
  Baby,
  ShieldAlert,
  Bone,
  Pill,
  Dumbbell,
  Hospital,
  Wind,
  Accessibility,
  Camera,
  Apple,
  Eye,
  Headphones,
  Image as ImageIcon,

  // Aliases for clarity
  Baby as BabyIcon,           // for Neonatology
  Stethoscope as Gastro,      // for Gastroenterology
} from "lucide-react";

const ToothIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-tooth"
>
<path d="M12 2C9 2 7 5 7 8c0 2 1 4 1 6s-1 4-1 6c0 1 1 2 2 2s2-1 2-2c0-2 0-4 1-6s1-4 1-6c0-3-2-6-5-6z" />
</svg>
)

const Departments = () => {
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "description": "MAMS Hospitals - A legacy of healing, compassion, and excellence in healthcare since 1992.",
    "foundingDate": "1996",
    "founder": {
      "@type": "Person",
      "name": "Sri Puvvada Nageswara Rao"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally, Hyderabad, Telangana – 500090",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "telephone": "+91-7399999981",
        "email": "contact@mamshospitals.com",
        "availableLanguage": ["English", "Hindi", "Telugu"]
      }
    ],
    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },

  {
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mamshospitals.com/departments"
  },
  "headline": "Our Departments – MAMS Hospitals",
  "description": "Explore the comprehensive healthcare departments at MAMS Hospitals, from super specialties like Neurosurgery and Oncology, to broad specialties like General Medicine, Orthopaedics, ENT, Ophthalmology, and more.",
  "author": {
    "@type": "Organization",
    "name": "MAMS Hospitals"
  },
  "publisher": {
    "@type": "Organization",
    "name": "MAMS Hospitals",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mamshospitals.com/MAMS-Logo.png"
    }
  },
  "datePublished": "2025-09-10",
  "dateModified": "2025-09-10",
  "articleSection": [
    "Super Specialties",
    "Broad Specialties",
    "Department Highlights"
  ],
  "about": {
    "@type": "MedicalOrganization",
    "name": "MAMS Hospitals",
    "url": "https://mamshospitals.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },
    "telephone": "+91-7399999981",
    "medicalSpecialty": [
      "Cardiology",
      "Cardiothoracic Surgery",
      "Neurology",
      "Neurosurgery",
      "Urology",
      "Nephrology",
      "Medical Oncology",
      "Surgical Oncology",
      "Endocrinology",
      "Plastic Surgery",
      "Pediatric Surgery",
      "Neonatology",
      "Medical & Surgical Gastroenterology",
      "General Medicine",
      "General Surgery",
      "Orthopaedics",
      "Obstetrics & Gynaecology",
      "Paediatrics",
      "Dermatology (DVL)",
      "ENT",
      "Ophthalmology",
      "Radiology & Imaging Sciences",
      "Psychiatry",
      "Emergency & Trauma",
      "Pain Medicine",
      "Sports Medicine",
      "Critical Care",
      "Anaesthesiology",
      "Dental",
      "Pulmonology",
      "Physiotherapy",
      "Radiology"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "telephone": "+91-7399999981",
      "availableLanguage": ["English", "Hindi", "Telugu"]
    },
    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },
  "keywords": [
    "MAMS Hospital Departments",
    "Super Specialty Hyderabad",
    "General Medicine Bachupally",
    "Neurosurgery Telangana"
  ]
}
];

  const superSpecialties = [
  {
     name: "Cardiology", 
    description: "Comprehensive heart care with advanced diagnostics and treatments.", 
    icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/cardiology.png"
        alt="Cardiology"
        className="w-8 h-8"
      />
    ),
    link: "/departments/cardiology"

  },
  // { name: "Cardiothoracic Surgery",
  //    description: "Surgical procedures for heart, lungs, and chest diseases.", 
  //    icon: <Activity className="w-8 h-8 text-teal-600" /> 
  //   },

  {
     name: "Neurology", 
    description: "Expert care for conditions affecting the brain and nervous system.",
    icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Neurology3.png"
        alt="Neurology"
        className="w-8 h-8"
      />
    ),
    link: "/departments/neurology" 
    },
  {
     name: "Neurosurgery",
      description: "Advanced surgical interventions for brain and spine disorders.", 
      icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Neurosurgery.png"
        alt="NeuroSurgery"
        className="w-8 h-8"
      />
    ),      
    link: "/departments/neurosurgery" 
     },
  { 
    name: "Urology",
     description: "Specialized care for urinary tract and male reproductive health.",
     icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/urology.png"
        alt="Urology"
        className="w-8 h-8"
      />
    ),       
    link: "/departments/urology"
  },
  { 
    name: "Nephrology", 
    description: "Treatment for kidney diseases and renal health management.",
    icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Nephrology.png"
        alt="Nephrology"
        className="w-8 h-8"
      />
    ),        
    link:"/departments/nephrology"
     },
  // { name: "Medical Oncology", description: "Comprehensive cancer care with personalized treatment plans.", icon: <Syringe className="w-8 h-8 text-teal-600" /> },
  // { name: "Surgical Oncology", description: "Surgical interventions for the treatment of various cancers.", icon: <Scissors className="w-8 h-8 text-teal-600" /> },
  { 
    name: "Endocrinology", 
    description: "Management of hormonal disorders and metabolic conditions.",
     icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Endocrinology.png"
        alt="Endocrinology"
        className="w-8 h-8"
      />
    ), 
     link:"/departments/endocrinology"
     },

  {
     name: "Plastic Surgery", 
    description: "Reconstructive and cosmetic surgical procedures.", 
    icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/plastic-surgery.png"
        alt="Plastic Surgery"
        className="w-8 h-8"
      />
    ),
     link: "/departments/plasticsurgery" 
  },
  { 
    name: "Pediatric Surgery", 
    description: "Specialized surgical care for infants, children, and adolescents.", 
    icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Pediatric-Surgery.png"
        alt="Pediatric Surgery"
        className="w-8 h-8"
      />
    ),
    link: "/departments/pediatric-surgery"
  },
  // { name: "Neonatology", description: "Care for newborns, including premature and critically ill babies.", icon: <BabyIcon className="w-8 h-8 text-teal-600" /> },
  { 
    name: "Medical & Surgical Gastroenterology",
     description: "Treatment for digestive system disorders and diseases.", 
     icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Gastroenterology.png"
        alt="Surgical Gastroenterology"
        className="w-8 h-8"
      />
    ),
     link: "/departments/gastroenterology"
  },
   { 
    //LEAN LIFE
    name: "Bariatric Surgery",
    description: "Bariatric Surgery is a wellness brand promoting healthy, balanced living.",
    icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Bariatric-Surgery.png"
        alt="Bariatric Surgery"
        className="w-8 h-8"
      />
    ),
    link: "/departments/leanlife"
    },
];


  const broadSpecialties = [
  {
     name: "General Medicine",
     description: "Primary healthcare for adults covering a wide range of conditions.", 
    icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/General-Medicine.png"
        alt="General Medicine"
        className="w-8 h-8"
      />
    ), 
    link: "/departments/general-medicine"
  },
  {
     name: "General Surgery", 
     description: "Surgical care for a variety of conditions requiring operative treatment.", 
     icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/General-Surgery.png"
        alt="General Surgery"
        className="w-8 h-8"
      />
    ), 
      link: "/departments/general-surgery"
     },
  {
    name: "Orthopaedics",
    description: "Expert care for bones, joints, ligaments, tendons, and muscles.",
    icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Orthopaedics.png"
        alt="Orthopaedics"
        className="w-8 h-8"
      />
    ), 
    link: "/departments/orthopaedics"
  }, 
  {
     name: "Obstetrics & Gynaecology",
      description: "Complete women's health care from adolescence to post-menopause.",
      icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Gynaecology.png"
        alt="Obstetrics & Gynaecology"
        className="w-8 h-8"
      />
    ),  
       link: "/departments/obstetrics-gynaecology"
  },
  { 
    name: "Paediatrics",
     description: "Specialized healthcare for infants, children, and adolescents.",
      icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Paediatrics.png"
        alt="Paediatrics"
        className="w-8 h-8"
      />
    ), 
      link: "/departments/paediatrics"
  },
  {
     name: "Dermatology (DVL)", 
     description: "Diagnosis and treatment of skin, hair, and nail conditions.", 
     icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Dermatology.png"
        alt="Dermatology"
        className="w-8 h-8"
      />
    ), 
     link: "/departments/dermatology"
     },
  { name: "ENT", 
    description: "Care for ear, nose, throat, and related head and neck disorders.", 
    icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/ENT.png"
        alt="ENT"
        className="w-8 h-8"
      />
    ), 
     link: "/departments/ent" 
  },
  { 
    name: "Ophthalmology",
     description: "Comprehensive eye care and vision services.",
      icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Ophthalmology.png"
        alt="Ophthalmology"
        className="w-8 h-8"
      />
    ), 
      link: "/departments/ophthalmology" 
  },
  {
     name: "Radiology & Imaging Sciences", 
     description: "Advanced diagnostic imaging services and interventions.",
      icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Radiology.png"
        alt="Radiology"
        className="w-8 h-8"
      />
    ), 
      link: "/departments/radiology" 
     },
  {
     name: "Psychiatry",
      description: "Mental health care and psychological support services.",
       icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Psychiatry.png"
        alt="Psychiatry"
        className="w-8 h-8"
      />
    ), 
      link: "/departments/psychiatry" 
  },
  {
     name: "Emergency & Trauma",
      description: "24/7 critical care for accidents, injuries, and medical emergencies.", 
      icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Emergency.png"
        alt="Emergency"
        className="w-8 h-8"
      />
    ), 
      link: "/departments/emergency-trauma" 
     },
  { 
    name: "Pain Medicine",
     description: "Management of acute and chronic pain conditions.",
     icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Pain-Medicine.png"
        alt="Pain Medicine"
        className="w-8 h-8"
      />
    ), 
     link: "/departments/pain-medicine" 
     },
  { 
    name: "Sports Medicine", 
    description: "Specialized care for sports-related injuries and performance enhancement.", 
    icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Sports-Medicine.png"
        alt="Sports Medicine"
        className="w-8 h-8"
      />
    ), 
    link: "/departments/sports-medicine" 
   },
  { 
    name: "Critical Care",
     description: "Intensive care for patients with severe or life-threatening illnesses.", 
     icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Critical-Care.png"
        alt="Critical Care"
        className="w-8 h-8"
      />
    ), 
    link: "/departments/critical-care" 
   },
  {
     name: "Anaesthesiology",
      description: "Ensuring patient comfort and safety during surgical procedures.",
       icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Anaesthesiology.png"
        alt="Anaesthesiology"
        className="w-8 h-8"
      />
    ), 
       link: "/departments/anaesthesiology" 
  },
  {
     name: "Dental",
      description: "Comprehensive dental care services for all age groups.",
      icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Dental.png"
        alt="Dental"
        className="w-8 h-8"
      />
    ), 
      link: "/departments/dental"
      },
   { 
    name: "Pulmonology", 
    description: "Treatment for respiratory system diseases and breathing disorders.",
    icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Pulmonology.png"
        alt="Pulmonology"
        className="w-8 h-8"
      />
    ), 
     link: "/departments/pulmonology"
   },
   {
     name: "Physiotherapy",
      description: "Helps restore movement and function through physical treatments and exercises.", 
      icon: (
      <img
      src="https://mamshospitals.mamscollege.com/wp-content/uploads/2026/06/Physiotherapy.png"
        alt="Physiotherapy"
        className="w-8 h-8"
      />
    ), 
      link: "/departments/physiotherapy"

     },
  // { name: "Radiology", description: "Radiology uses medical imaging to diagnose and monitor diseases and conditions.", icon: <Camera className="w-8 h-8 text-teal-600" /> },
 
];


  const renderDepartmentCard = (dept, index) => (
  <Link
    key={index}
    className="h-full flex items-start gap-4 transition-all hover:shadow-md hover:border-teal-600 border border-gray-200 p-6 rounded-lg bg-white"
    to={dept.link}
  >
    {/* Icon Section */}
    <div className="flex-shrink-0 text-teal-600 text-3xl">
      {dept.icon} {/* You can pass an icon component or emoji in dept.icon */}
    </div>

    {/* Content Section */}
    <div>
      <h3 className="mb-2 text-lg font-semibold text-gray-800">{dept.name}</h3>
      <p className="text-gray-600">{dept.description}</p>
    </div>
  </Link>
);

  

  return (
    <>
      <SEO
        title="MAMS Hospital Departments – Multispecialty Care at MAMS Bachupally"
        description="Explore Clinical Departments at Mamatha Academy of Medical Sciences Hospital in Bachupally – from Medicine, Surgery, Paediatrics, OBG to Radiology, ENT, Psychiatry & more."
        keywords="Hyderabad's Best Multispecialty Hospital, Best Hospital near Bachupally Hyderabad, Best Hospital near Miyapur Hyderabad, Best Hospital near Nizampet, Multispecialty Hospital near KPHB Colony, Emergency Hospital near JNTU Hyderabad, 24-hour Hospital in Bachupally Hyderabad, Emergency Care Hospital in Hyderabad, Best Cardiology Hospital in Hyderabad, Best Neurology Hospital Hyderabad, Orthopaedics Hospital in Bachupally Hyderabad, Best Joint Replacement Hospital Hyderabad, Spine Surgery Specialist Hyderabad, Best ENT Hospital in Hyderabad, Best Gynecology Hospital Hyderabad, Maternity & Child Care Hospital Hyderabad, Best Pediatric Hospital in Bachupally, Neonatal ICU Hospital Hyderabad, General Medicine Specialist Hyderabad, Best General Surgery Hospital Hyderabad, Critical Care Hospital near Miyapur Hyderabad, Best Physiotherapy Hospital Hyderabad, Mamata Academy of Medical Sciences hospital,General Medicine, Dermatology, ENT, Pulmonology, Radiology, Psychiatry, Obstetrics & Gynaecology, Orthopaedics, Anaesthesiology, Ophthalmology, Paediatrics departments MAMS Hospital Hyderabad"
        schema={schema}
      canonicalUrl="https://mamshospitals.com/departments"
      />

    <div className="flex flex-col min-h-screen">
      {/* Hero Section */}
      <section className="bg-primary/5 py-12 md:py-12">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-6">Our Departments</h1>
            <p className="text-lg text-gray-600">
              Comprehensive healthcare with specialized expertise across a wide range of medical disciplines.
            </p>
          </div>
        </div>
      </section>

      {/* Super Specialties */}
      <section className="py-8 md:py-16 px-0 md:px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="mb-10">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Super Specialties</h2>
            <p className="text-gray-600 mb-8">
              Our super specialty departments offer advanced care for complex medical conditions, with cutting-edge
              technology and expert specialists.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {superSpecialties.map(renderDepartmentCard)}
            </div>
          </div>
        </div>
      </section>

      {/* Broad Specialties */}
      <section className="py-8 md:py-16 px-0 md:px-4 bg-primary/5">
        <div className="container mx-auto max-w-6xl">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Broad Specialties</h2>
            <p className="text-gray-600 mb-8">
              Our broad specialty departments provide comprehensive care for common and general medical concerns,
              ensuring holistic patient care.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {broadSpecialties.map(renderDepartmentCard)}
            </div>
          </div>
        </div>
      </section>

      {/* Department Highlights */}
      <section className="py-8 md:py-16 px-0 md:px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-primary mb-4">Department Highlights</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Discover some of our key departments and their specialized services.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg border border-slate-100 shadow-sm">
              <h3 className="text-xl font-bold text-primary mb-3">Anaesthesiology</h3>
              <p className="text-gray-700 mb-4">
                Ensuring patient comfort and safety during surgical procedures through advanced anaesthesia care.
              </p>
              <div className="relative h-48 rounded overflow-hidden">
                <img
                  src={Anaesthesiology}
                  alt="Anaesthesiology Department"
                  className="object-cover w-full h-full"
                />
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg border border-slate-100 shadow-sm">
              <h3 className="text-xl font-bold text-primary mb-3">General Medicine</h3>
              <p className="text-gray-700 mb-4">
                Expert management of adult diseases with a focus on accurate diagnosis and personalized treatment.
              </p>
              <div className="relative h-48 rounded overflow-hidden">
                <img
                  src= {GeneralMedicine}
                  alt="General Medicine Department"
                  className="object-cover w-full h-full"
                />
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg border border-slate-100 shadow-sm">
              <h3 className="text-xl font-bold text-primary mb-3">Obstetrics & Gynaecology</h3>
              <p className="text-gray-700 mb-4">
                Complete women's health care including pregnancy, fertility, and hormonal treatments.
              </p>
              <div className="relative h-48 rounded overflow-hidden">
                <img
                  src= {Obstetrics}
                  alt="Obstetrics & Gynaecology Department"
                  className="object-cover w-full h-full"
                />
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg border border-slate-100 shadow-sm">
              <h3 className="text-xl font-bold text-primary mb-3">Orthopaedics</h3>
              <p className="text-gray-700 mb-4">
                Advanced treatments and surgeries for bones, joints, and spine — ensuring long-term mobility.
              </p>
              <div className="relative h-48 rounded overflow-hidden">
                <img
                  src={Orthopaedics}
                  alt="Orthopaedics Department"
                  className="object-cover w-full h-full"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-8 md:py-16 px-0 md:px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="bg-white rounded-xl border border-gray-200 p-8 md:p-12 shadow-lg">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="md:w-2/3">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                  Need Help Finding the Right Department?
                </h2>
                <p className="text-gray-600 mb-6">
                  Our medical experts can guide you to the appropriate specialty based on your symptoms and medical
                  history. Contact us for assistance or schedule an appointment with our general medicine department for
                  an initial assessment.
                </p>
                {/* <div className="flex flex-col sm:flex-row gap-4">
                  <Link to="/contact">
                    <button className="bg-teal-600 text-white px-6 py-3 rounded-full font-medium hover:bg-teal-700 transition-colors">
                      Contact Us
                    </button>
                  </Link>
                   <Link to="/book-appointment">
                    <button className="bg-gray-100 text-gray-800 px-6 py-3 rounded-full font-medium hover:bg-gray-200 transition-colors">
                      Book Appointment
                    </button>
                  </Link>
                </div> */}
              </div>
              <div className="md:w-1/3">
                <img src={BannerImg1} alt="Medical Guidance" className="rounded-lg w-full" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
  )
}

export default Departments
